import { taskListActionType } from '../../constants/index';

export default (state = [], action) => {
  switch (action.type) {
    case taskListActionType.FETCH_TASKS:
      return action.payload;
    default:
      return state;
  }
};
